import { render } from "./SidebarScroll.vue?vue&type=template&id=302b7948&scoped=true"
import script from "./SidebarScroll.vue?vue&type=script&lang=js"
export * from "./SidebarScroll.vue?vue&type=script&lang=js"

import "./SidebarScroll.vue?vue&type=style&index=0&id=302b7948&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-302b7948"]])

export default __exports__